import { useCallback, useEffect, useState } from "react";
import PaymentProviderCustomersService from "../../../../../../services/userManagement/paymentProviderCustomers";
import { useAppDispatch } from "../../../../../../store";
import { setErrorMessage } from "../../../../../../acions/actionsCreators/messageActions";

export const useFetchData = (userId: string | null) => {
  const dispatch = useAppDispatch();

  const [data, setData] = useState<any | null>(null);

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchData = useCallback(async () => {
    try {
      const res = await PaymentProviderCustomersService.fetchSingle(userId);
      setData(res);
      setIsLoading(false);
    } catch (e: any) {
      const data = e.response.data;
      data.status === 400 && dispatch(setErrorMessage(e.response.data.title, true));
      setIsLoading(false);
    }
  }, [dispatch, userId]);

  useEffect(() => {
    userId && fetchData();
  }, [fetchData, userId]);

  return { data, isLoading };
};
